import React from 'react';
import { useSelector, useDispatch } from 'react-redux'
import { useTranslation } from 'react-i18next';

// Redux slices
import { closeModal, openModal } from '../../appSlice'

/*
 * https://date-fns.org/v4.1.0/docs/addDays
 * https://www.npmjs.com/package/react-datepicker
 * https://reactdatepicker.com/#example-locale-without-global-variables
 */
import { registerLocale, setDefaultLocale } from  "react-datepicker";
import format from 'date-fns/format'
import { de } from 'date-fns/locale/de';

// SemanticUI components
import { Container, Modal, Icon, Grid, GridRow, GridColumn, Header, Accordion, Segment, Label } from 'semantic-ui-react';


registerLocale('de', de);
setDefaultLocale('de');


/**
 * 
 * @returns 
 */
const Max2ModalProfile = () => {
    // global State
    const dispatch = useDispatch();
    const open          = useSelector((state) => state.app.modal.profile.open);
    const userDetails   = useSelector((state) => state.app.modal.profile.data);

    const { t } = useTranslation();

    // check if modal is active
    if (!open) {
        return <></>
    };


    // build group checkboxes
    let groupCheckboxes = [];
    for (const key in userDetails.groups) {
        if (Object.prototype.hasOwnProperty.call(userDetails.groups, key)) {
            const group = userDetails.groups[key];
            groupCheckboxes.push(<><Icon circular name='users' />{group.name}<br /></>);
        }
    }

    // Reference-User
    let ref_user = '';
    if (typeof userDetails?.reference_details?.uname !== 'undefined') {
        ref_user = userDetails.reference_details.uname;
    }

    // build assigned objectcodes list
    let objectcodesGrouped = {};
    userDetails?.objectCodes?.forEach(objectCode => {
        if (typeof objectcodesGrouped[objectCode.zgb_id] === 'undefined') {
            objectcodesGrouped[objectCode.zgb_id] = {
                key: objectCode.zgb_id,
                title: objectCode.zgb_name,
                objectCodes: [],
                content: []
            }
        }
        objectcodesGrouped[objectCode.zgb_id].objectCodes.push(objectCode.name);
        objectcodesGrouped[objectCode.zgb_id].content.push(<>&nbsp;&nbsp;&nbsp;&nbsp;&bull;&nbsp;{objectCode.name}<br /></>)
    });
    const objectCodesAccordion = <Accordion defaultActiveIndex={[0]} panels={objectcodesGrouped} exclusive={false} />

    // Date formatting
    const regdate   = userDetails.regdate ? format(new Date(userDetails.regdate * 1000), 'dd.MM.yyyy HH:mm') + (t('settings.userDetails.timeSuffix') ? ' ' + t('settings.userDetails.timeSuffix') : '') : '';
    const lastlogin = userDetails.lastlogin ? format(new Date(userDetails.lastlogin * 1000), 'dd.MM.yyyy HH:mm') + (t('settings.userDetails.timeSuffix') ? ' ' + t('settings.userDetails.timeSuffix') : '') : '';

  
    return (
        <Modal closeIcon dimmer="blurring" open={open} size="large" onClose={() => dispatch(closeModal('profile'))}>
            <Modal.Header>{t('settings.userDetails.profileTitle', { username: userDetails.uname })}</Modal.Header>
            <Modal.Content scrolling>
                <Segment>
                    <Grid style={{margin: '25px'}}>
                        <GridRow> 
                            <GridColumn width={8}>
                                <Header as='h4'>{t('settings.userDetails.details')}</Header>
                                <Grid>
                                    <GridRow className='ro_row'><GridColumn width={5} className='ro_label' textAlign='right'>{t('settings.userDetails.username')}</GridColumn><GridColumn width={11}>{userDetails.uname}</GridColumn></GridRow>
                                    <GridRow className='ro_row'><GridColumn width={5} className='ro_label' textAlign='right'>{t('settings.userDetails.email')}</GridColumn><GridColumn width={11}>{userDetails.email}</GridColumn></GridRow>
                                </Grid>
                                <br /><br />
                                <Grid>
                                    <GridRow className='ro_row'><GridColumn width={5} className='ro_label' textAlign='right'>{t('settings.userDetails.displayName')}</GridColumn><GridColumn width={11}>{userDetails.displayname}</GridColumn></GridRow>
                                    <GridRow className='ro_row'><GridColumn width={5} className='ro_label' textAlign='right'>{t('settings.userDetails.forename')}</GridColumn><GridColumn width={11}>{userDetails.forename}</GridColumn></GridRow>
                                    <GridRow className='ro_row'><GridColumn width={5} className='ro_label' textAlign='right'>{t('settings.userDetails.surname')}</GridColumn><GridColumn width={11}>{userDetails.surename}</GridColumn></GridRow>
                                    <GridRow className='ro_row'><GridColumn width={5} className='ro_label' textAlign='right'>{t('settings.userDetails.phone')}</GridColumn><GridColumn width={11}>{userDetails.telephone}</GridColumn></GridRow>
                                    {/*<GridRow className='ro_row'><GridColumn width={5} className='ro_label' textAlign='right'>{t('settings.userDetails.language')}</GridColumn><GridColumn width={11}><Flag name={userDetails.language === 'german' ? 'de' : 'uk'} /></GridColumn></GridRow>*/}
                                </Grid>
                                <br /><br />
                                <Grid>
                                    <GridRow className='ro_row'><GridColumn width={5} className='ro_label' textAlign='right'>{t('settings.userDetails.agency')}</GridColumn><GridColumn width={11}>{userDetails?.agency?.name}</GridColumn></GridRow>
                                </Grid>
                                <br /><br />
                                <Grid>
                                    <GridRow className='ro_row'><GridColumn width={5} className='ro_label' textAlign='right'>{t('settings.userDetails.referenceUser')}</GridColumn><GridColumn width={11}>
                                        <Label as='a' onClick={()=>{dispatch(openModal({type: 'profile', data: userDetails.reference_details}))}}>
                                            <Icon name='user circle' /> {ref_user}
                                        </Label>
                                        </GridColumn>
                                    </GridRow>
                                </Grid>
                                <br /><br />
                                <Grid>
                                    <GridRow className='ro_row'><GridColumn width={5} className='ro_label' textAlign='right'>{t('settings.userDetails.lastLogin')}</GridColumn><GridColumn width={11}>{lastlogin}</GridColumn></GridRow>
                                    <GridRow className='ro_row'><GridColumn width={5} className='ro_label' textAlign='right'>{t('settings.userDetails.registrationDate')}</GridColumn><GridColumn width={11}>{regdate}</GridColumn></GridRow>
                                </Grid>
                                <br /><br />
                                <Grid>
                                    <GridRow className='ro_row'>
                                    <GridColumn width={5} className='ro_label' textAlign='right'>{t('settings.userDetails.groupMembership')}</GridColumn>
                                    <GridColumn width={11}>{groupCheckboxes}</GridColumn>
                                    </GridRow>
                                </Grid>
                            </GridColumn>

                            <GridColumn width={4}>
                                <Header as='h4'>{t('settings.userDetails.rightsAccessControl')}</Header>
                                <Container style={{maxHeight: '800px', overflow: 'auto', borderTop: '1px solid silver', padding: '10px'}}>
                                    <label>{t('settings.userDetails.systemControl')}</label><br />
                                    <div style={{padding: '10px', marginBottom: '25px'}}>
                                        {userDetails?.permissions?.system?.read && (<><Icon circular name='check' />{t('settings.userDetails.perms.read')}<br /></>)}
                                        {userDetails?.permissions?.system?.write && (<><Icon circular name='check' />{t('settings.userDetails.perms.write')}<br /></>)}
                                    </div>

                                    <label>{t('settings.userDetails.object')}</label><br />
                                    <div style={{padding: '10px', marginBottom: '25px'}}>
                                        {userDetails?.permissions?.object?.read && (<><Icon circular name='check' />{t('settings.userDetails.perms.read')}<br /></>)}
                                        {userDetails?.permissions?.object?.write && (<><Icon circular name='check' />{t('settings.userDetails.perms.write')}<br /></>)}
                                        {userDetails?.permissions?.object?.addMedia && (<><Icon circular name='check' />{t('settings.userDetails.perms.hotelImages')}<br /></>)}
                                        {userDetails?.permissions?.object?.descriptions && (<><Icon circular name='check' />{t('settings.userDetails.perms.hotelDescriptions')}<br /></>)}
                                        {userDetails?.permissions?.object?.contracts && (<><Icon circular name='check' />{t('settings.userDetails.perms.contracts')}<br /></>)}
                                        {userDetails?.permissions?.object?.exports && (<><Icon circular name='check' />{t('settings.userDetails.perms.exports')}<br /></>)}
                                    </div>

                                    <label>{t('settings.userDetails.contract')}</label><br />
                                    <div style={{padding: '10px', marginBottom: '25px'}}>
                                        {userDetails?.permissions?.contract?.read && (<><Icon circular name='check' />{t('settings.userDetails.perms.read')}<br /></>)}
                                        {userDetails?.permissions?.contract?.write && (<><Icon circular name='check' />{t('settings.userDetails.perms.write')}<br /></>)}
                                        {userDetails?.permissions?.contract?.headoffice && (<><Icon circular name='check' />{t('settings.userDetails.perms.extendedViewHeadOffice')}<br /></>)}
                                        {userDetails?.permissions?.contract?.management && (<><Icon circular name='check' />{t('settings.userDetails.perms.contractAdministration')}<br /></>)}
                                    </div>

                                    <label>{t('settings.userDetails.allotments')}</label><br />
                                    <div style={{padding: '10px', marginBottom: '25px'}}>
                                        {userDetails?.permissions?.allotments?.read && (<><Icon circular name='check' />{t('settings.userDetails.perms.read')}<br /></>)}
                                        {userDetails?.permissions?.allotments?.write && (<><Icon circular name='check' />{t('settings.userDetails.perms.write')}<br /></>)}
                                    </div>
                                </Container>
                            </GridColumn>

                            <GridColumn width={4}>
                                <Header as='h4'>{t('settings.userDetails.objectCodesAssignments')}</Header>
                                <Container style={{maxHeight: '800px', overflow: 'auto', borderTop: '1px solid silver', padding: '10px'}}>
                                    {objectCodesAccordion}
                                </Container>
                            </GridColumn>
                        </GridRow>
                    </Grid>
                </Segment>
            </Modal.Content>
        </Modal>
    )
}

export default Max2ModalProfile;